import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ModuleFE_AdvisorStatic } from '../ModuleFE_AdvisorStatic.js';
import { DBDef_NoteTemplate, ensureDispositionSectionFlag } from '@app/advisor-content-shared';
export const dispatch_onNoteTemplatesUpdated = new ThunderDispatcherV3('__onNoteTemplatesUpdated');
class ModuleFE_Advisor_NoteTemplate_Class extends ModuleFE_AdvisorStatic {
    constructor() {
        super(DBDef_NoteTemplate, dispatch_onNoteTemplatesUpdated);
        this.registerVersionUpgradeProcessor('1.0.2', this.upgrade_102);
    }
    upgrade_102 = async (items) => {
        items.forEach(item => ensureDispositionSectionFlag(item.sections));
    };
}
export const ModuleFE_Advisor_NoteTemplate = new ModuleFE_Advisor_NoteTemplate_Class();
//# sourceMappingURL=note-template.js.map